var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 92,
    viewBox: "0 0 80 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4286 40.25H67.1429V27.3125C67.1429 12.2547 54.9643 0 40 0C25.0357 0 12.8571 12.2547 12.8571 27.3125V40.25H8.57143C3.83929 40.25 0 44.1133 0 48.875V83.375C0 88.1367 3.83929 92 8.57143 92H71.4286C76.1607 92 80 88.1367 80 83.375V48.875C80 44.1133 76.1607 40.25 71.4286 40.25ZM47.1429 70.4375C47.1429 74.4086 43.9464 77.625 40 77.625C36.0536 77.625 32.8571 74.4086 32.8571 70.4375V61.8125C32.8571 57.8414 36.0536 54.625 40 54.625C43.9464 54.625 47.1429 57.8414 47.1429 61.8125V70.4375ZM52.8571 40.25H27.1429V27.3125C27.1429 20.1789 32.9107 14.375 40 14.375C47.0893 14.375 52.8571 20.1789 52.8571 27.3125V40.25Z",
    fill: "#1E88E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.24c1041098b6b0f62a733445f89d7347.svg";
export { ForwardRef as ReactComponent };